import { useDataset } from "@/hooks/map/useDataset";
import { Dataset } from "@/types/dataset";

import SliderInput from "./SliderInput";

type OpacitySliderProps = {
  data: Dataset;
  isSpatialAnalysis?: boolean;
  type?: "fill" | "label" | "stroke";
};

export default function OpacitySlider(props: Readonly<OpacitySliderProps>) {
  const { data, type } = props;
  const {
    handleChangeOpacityDataset,
    handleChangeLabelOpacity,
    handleChangeStrokeOpacityDataset
  } = useDataset();

  const handleChangeOpacity = (value: number) => {
    if (value > 100) value = 100;
    if (value < 0) value = 0;
    const opacity = value / 100;

    if (type === "label") {
      handleChangeLabelOpacity(data, opacity);
    } else if (type === "stroke") {
      handleChangeStrokeOpacityDataset(data.data.id, opacity);
    } else {
      handleChangeOpacityDataset(data.data.id, opacity);
    }
  };

  const handleChangeOpacitySlider = (value: number[]) => {
    const opacity = value[0] / 100;

    if (type === "label") {
      handleChangeLabelOpacity(data, opacity);
    } else if (type === "stroke") {
      handleChangeStrokeOpacityDataset(data.data.id, opacity);
    } else {
      handleChangeOpacityDataset(data.data.id, opacity);
    }
  };

  const getOpacity = () => {
    if (type === "label") return data?.style?.labelConfig?.opacity || 0;
    if (type === "stroke") return data?.style?.stroke?.opacity || 0;
    return data.style.fillOpacity;
  };

  const opacity = getOpacity();
  const opacityValue = [opacity * 100];
  const opacityInputValue = Math.round(opacity * 100);

  return (
    <div className="flex flex-col gap-2 w-full">
      <p className="text-xs text-txtPlaceholder">Opacity</p>
      <SliderInput
        valueSlider={opacityValue}
        onChangeSlider={handleChangeOpacitySlider}
        valueInput={opacityInputValue}
        onChangeInput={handleChangeOpacity}
      />
    </div>
  );
}
